import {
  ACQUISITION_CODE_CHOICES,
  IMPACT_CHOICES,
  PLANNING_METHOD_CHOICES,
  PLANNING_POLICY_CHOICES,
  PRODUCT_STATUS_CHOICES,
  PRODUCT_TYPE_CHOICES,
  PRODUCT_UOM_CHOICES,
  STOCK_LINE_STATUS_CHOICES,
  STOCK_TYPE_CHOICES,
  WAREHOUSE_TYPE_CHOICES,
  LANDED_COST_TYPE_CHOICES,
  PAYMENT_TERM_TYPE_CHOICES,
  PURCHASE_ORDER_PRIORITY,
  COST_ALLOCATION_METHOD,
  SYNC_FREQUENCY_CHOICES,
  BANK_ACCOUNT_CHOICES,
  ALLOCATED_COST_TO_CHOICES,
  MONTHLY_CHOICES,
  CURRENCY_FREQUENCY_CHOICES,
  TRACKING_METHOD_CHOICES,
  TRACKING_NUMBERING_METHOD_CHOICES,
  REPLENISHMENT_CALCULATION_METHOD_CHOICES,
  BATCH_NO_CHOICES,
  CUSTOMER_STATUS_CHOICES,
  CUSTOMER_TYPE_CHOICES,
  INVENTORY_VALUATION_METHOD_CHOICES,
  SALE_STOCK_DEPLETION_TRIGGER_CHOICES,
  PAYMENT_STATUS_SOURCE_CHOICES,
  PREPAYMENT_TYPE_CHOICES,
  CUSTOMER_SUB_TYPE_CHOICES,
  COUNTRIES_CHOICES,
  UOM_CATEGORY_CHOICES,
  CHANNEL_CHOICES,
  PRICE_LOGIC_CHOICES,
  PRICE_BASE_CHOICES,
  EXTRA_FEE_DIRECTION_CHOICES,
  DELIVERY_PRIORITY_CHOICES,
  FREIGHT_TYPE_CHOICES,
  INCOTERM_CHOICES,
  TRANSPORT_MODE_CHOICES,
  LEG_TYPE_CHOICES,
  SHOPIFY_ORDER_IMPORT_TRIGGER_CHOICES,
  SHOPIFY_CONSOLIDATE_ORDERS_CHOICES,
  SHOPIFY_CONSOLIDATION_TIME_CHOICES,
  SHOPIFY_ORDER_FULFILLMENT_PROCESS_CHOICES,
  SHOPIFY_CATALOGUE_SOURCE_CHOICES,
  SHOPIFY_INVOICE_STATUS_CHOICES,
  SHOPIFY_STOCK_SOURCE_CHOICES,
  AUTO_MANUAL_CHOICES,
  OPERATION_TYPE_CHOICES,
} from "../../../constant/data";

export const OPTIONS_MAPPINGS = {
  acquisitionCode: ACQUISITION_CODE_CHOICES,
  planningPolicy: PLANNING_POLICY_CHOICES,
  planningMethod: PLANNING_METHOD_CHOICES,
  productStatus: PRODUCT_STATUS_CHOICES,
  productType: PRODUCT_TYPE_CHOICES,
  productUOM: PRODUCT_UOM_CHOICES,
  warehouseType: WAREHOUSE_TYPE_CHOICES,
  stockType: STOCK_TYPE_CHOICES,
  stockLineStatus: STOCK_LINE_STATUS_CHOICES,
  impact: IMPACT_CHOICES,
  landedCostType: LANDED_COST_TYPE_CHOICES,
  termType: PAYMENT_TERM_TYPE_CHOICES,
  priority: PURCHASE_ORDER_PRIORITY,
  deliveryPriority: DELIVERY_PRIORITY_CHOICES,
  costAllocationMethod: COST_ALLOCATION_METHOD,
  amountType: [
    { id: "exclusive", name: "Tax Excluded" },
    { id: "inclusive", name: "Tax Included" },
    { id: "no_tax", name: "No Tax" },
  ],
  syncFrequency: SYNC_FREQUENCY_CHOICES,
  bankAccount: BANK_ACCOUNT_CHOICES,
  allocatedCostTo: ALLOCATED_COST_TO_CHOICES,
  trackingMethod: TRACKING_METHOD_CHOICES,
  monthly: MONTHLY_CHOICES,
  currencyFrequency: CURRENCY_FREQUENCY_CHOICES,
  trackingNumberingMethod: TRACKING_NUMBERING_METHOD_CHOICES,
  batchNoType: BATCH_NO_CHOICES,
  replenishmentCalculationMethod: REPLENISHMENT_CALCULATION_METHOD_CHOICES,
  customerStatus: CUSTOMER_STATUS_CHOICES,
  customerType: CUSTOMER_TYPE_CHOICES,
  inventoryValuationMethod: INVENTORY_VALUATION_METHOD_CHOICES,
  saleStockDepletionTrigger: SALE_STOCK_DEPLETION_TRIGGER_CHOICES,
  paymentStatusSource: PAYMENT_STATUS_SOURCE_CHOICES,
  prepaymentType: PREPAYMENT_TYPE_CHOICES,
  customerSubType: CUSTOMER_SUB_TYPE_CHOICES,
  countryOptions: COUNTRIES_CHOICES,
  uomCategory: UOM_CATEGORY_CHOICES,
  channel: CHANNEL_CHOICES,
  priceLogic: PRICE_LOGIC_CHOICES,
  priceBase: PRICE_BASE_CHOICES,
  extraFeeDirection: EXTRA_FEE_DIRECTION_CHOICES,
  freightType: FREIGHT_TYPE_CHOICES,
  incoterm: INCOTERM_CHOICES,
  legType: LEG_TYPE_CHOICES,
  transportMode: TRANSPORT_MODE_CHOICES,
  shopifyOrderImportTrigger: SHOPIFY_ORDER_IMPORT_TRIGGER_CHOICES,
  shopifyConsolidateOrders: SHOPIFY_CONSOLIDATE_ORDERS_CHOICES,
  shopifyConsolidationTime: SHOPIFY_CONSOLIDATION_TIME_CHOICES,
  shopifyOrderFulfillmentProcess: SHOPIFY_ORDER_FULFILLMENT_PROCESS_CHOICES,
  shopifyInvoiceStatus: SHOPIFY_INVOICE_STATUS_CHOICES,
  shopifyCatalogueSource: SHOPIFY_CATALOGUE_SOURCE_CHOICES,
  shopifyStockSource: SHOPIFY_STOCK_SOURCE_CHOICES,
  autoManual: AUTO_MANUAL_CHOICES,
  operationType: OPERATION_TYPE_CHOICES,
  numberPrecision: [
    { id: "2", name: "Up to 2 decimal places" },
    { id: "4", name: "Up to 4 decimal places" },
    { id: "8", name: "Up to 8 decimal places" },
  ],
  dateDisplay: [
    { id: "date", name: "Date only" },
    { id: "date_time", name: "Date and time" },
  ],
};
